export default "__VITE_ASSET__BQ8JGPTF__"